<template lang="html">
  <div class="CRUDGenerico__Wrapper" v-if="canAccessPage">
    <v-row>
      <v-col cols="12" sm="3" v-if="!somenteLeitura">
        <tipo-uso-form
          ref="tipoUsoForm"
          @FORMULARIO_CADASTRO_TIPO_USO_SALVAR="onTipoUsoSalvo"
        />
      </v-col>
      <v-col cols="12" :sm="somenteLeitura ? 12 : 9">
        <tipo-uso-lista
          ref="tipoUsoTabela"
          class="CRUDGenerico__ContentTable"
          :title="$tc('label.tipo_uso', 2)"
          @PESQUISA_TIPO_USO_EDITAR="onEditarTipoUso"/>
      </v-col>
    </v-row>
  </div>
</template>

<script type="text/javascript">
import { generateComputed } from '@/common/functions/roles-computed-generator';
import TipoUsoForm from './TipoUsoForm';
import TipoUsoLista from './TipoUsoLista';

export default {
  name: 'TipoUsoCadastro',
  data() {
    return {
    };
  },
  components: {
    TipoUsoForm,
    TipoUsoLista,
  },
  computed: {
    ...generateComputed('TIPO_USO', [
      'canAccessCRUD',
      'canAccessPage',
    ]),
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast(this.$t('message.acesso_negado'));
      }
    },
    onEditarTipoUso(tipoUso) {
      this.$refs.tipoUsoForm.editar(tipoUso);
    },
    onTipoUsoSalvo() {
      this.$refs.tipoUsoTabela.filtrar();
    },
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    }
  },
};
</script>
<style scoped>
.CRUDGenerico__ContentTable  {
  width: 100%;
}
</style>
